// const Url = "https://client.securefx.net";
// const Url = "https://referral.securefx.net";
const Url=".";

var fullURL = window.location.href;
var baseURL = fullURL.split("/").slice(0, 3).join("/");

// const IsApprove = {
//   is_app: 1,
//   auth: "8c5179-1cab64-e6d69d" ,
//   user_id: "1",
//   is_crm: 1,
// };
const IsApprove = "";
export { Url, IsApprove,baseURL };
